import React, { useRef, useState, useEffect } from 'react'
import { leftMenuToggle, rightMenuToggle } from 'store/actions/home'
import { addActiveCompanyData } from 'store/actions/user'
import { signout } from 'store/actions/login'
import { useActions } from '../../../../hooks/useActions'
import { useHistory, useLocation } from 'react-router-dom'
import { Button, Dropdown, Menu } from 'antd'


import CustomTooltip from 'components/Tooltip'

import {
    StarIco,
    StarGreenIco,
    DropdownIco
} from '../../../../../modules/CustomIcons'

import { connect } from 'react-redux'

import '../../../main.layout.scss'
import { getCurrentCompany } from '../../../../services/user'
import { setFavCompany } from '../../../../services/user'

import type { Scrollbar as BaseScrollbar } from 'smooth-scrollbar/scrollbar'
import { GetLastLogin, getLastLoginList } from "../../../../services/Auth/GetLastLogin";
import { secureLocalStorageGet, secureLocalStorageSet } from '../../../../helpers'
import { useTranslation } from 'react-i18next'
import { clearSalaryListFunc } from "store/actions/salary";
import useResponsiveWidth from 'hooks/useResponsiveWidth'


const Profile: React.FC<any> = ({ leftMenuStatus, rightMenuStatus, companyData, loading }) => {
    const { t } = useTranslation();
    const location = useLocation()
    const { leftMenuToggle, rightMenuToggle, signout, addActiveCompanyData, clearSalaryListFunc } = useActions()
    const [menuItem, setMenuItem] = useState(getCurrentCompany()?.name)
    const [settingsDrawerVisible, setSettingsDrawerVisible] = useState(false)
    const scrollbar = useRef<BaseScrollbar | null>(null)
    const [open, setOpen] = useState<any>([0])
    const [favIndex, setFav] = useState(0)
    const [favItem, setFavItem] = useState(getCurrentCompany()?.customerNo)
    const [companyDataState, setCompanyData] = useState(getCurrentCompany())
    const [loginDates, setLoginDates] = useState<GetLastLogin[]>()
    const [loginDatesFirst, setLoginDatesFirst] = useState<GetLastLogin>()
    const [isOpenDropdown, setIsOpenDropdown] = useState(false)
    const responsiveWidth = useResponsiveWidth();


    const settingsDrawerClose = () => {
        setSettingsDrawerVisible(false)
    }

    const history = useHistory()


    let userData = secureLocalStorageGet('userData')

    const setFavCompanyData = async (e, index) => {

        e.stopPropagation()
        e.preventDefault()
        let customerNo = companyData.customers !== undefined
            ? companyData.customers.asanCustomerList[index].customerNo
            : companyData.customerNo
        setFavItem(customerNo)
        let postData = { customerNo: customerNo }
        let favData = await setFavCompany(postData)
        setFav(favData)
    }

    const getLastLoginDates = async () => {
        const data = await getLastLoginList();

        setLoginDates(old_data => data);
        setLoginDatesFirst(old_data => data.find((row, index) => index === 0));
    }

    // useEffect(() => {
    //     if (responsiveWidth < 650) {
    //         const fetchCompanyData = async () => {
    //             let postData = { customerNo: getCurrentCompany()?.customerNo }
    //             addActiveCompanyData(postData)
    //             // const companyData = await addActiveCompanyData(postData)
    //             // setCompanyData(companyData)
    //         }
    //         //
    //         if (!loading ) {
    //             fetchCompanyData();
    //             // settingsDrawerClose();
    //             // getLastLoginDates();
    //         }
    //     }


    // }, [1])


    useEffect(() => {
        if (responsiveWidth < 650) {
            if (!loading) {
                setMenuItem((companyData && companyData.customerName) ? companyData.customerName : companyData)
                settingsDrawerClose();
                getLastLoginDates();
            }
        }
    }, [companyData, loading])

    const handleMenuItem = async ({ key }) => {
        event.stopPropagation()
        event.preventDefault()

        setIsOpenDropdown(false);
        const userInfo = userData?.customerData?.[key]
        // localStorage.setItem(
        //   'currentCompany',
        //   JSON.stringify(userInfo)
        // )
        secureLocalStorageSet('currentCompany', userInfo);
        let postData = { customerNo: userInfo['customerNo'], history: history }
        await clearSalaryListFunc();

        await addActiveCompanyData(postData)
    }

    const drop_down_menus = (
        <Menu
            style={{ width: 221 }}
            className="header-dropdown-menu companies_drop_down"
            onClick={handleMenuItem}
        >
            {userData &&
                userData?.customerData.map((item: object, index: number) => {
                    return (
                        <Menu.Item
                            key={index}
                            className={item.name == menuItem ? 'active' : ''}
                        >
                            {item.name.length > 38 ? (
                                <CustomTooltip
                                    className="header-dropdown-menu__tooltip"
                                    placement="bottom"
                                    title={item.name}
                                >
                                    <div>{item.name}</div>
                                    {/* <Link to={'/'}>{item.name}</Link> */}
                                </CustomTooltip>
                            ) : (
                                <div>{item.name}</div>
                            )}
                            <CustomTooltip
                                className="header-dropdown-menu__tooltip"
                                placement="topRight"
                                title={t("home.determiningCompany")}
                            >
                                <Button
                                    className='favourite-star'
                                    onClick={(event) => setFavCompanyData(event, index)}
                                    icon={
                                        item.customerNo == favItem ? (
                                            <StarGreenIco className="starIcoActive" />
                                        ) : (
                                            <StarIco className="startIcon" />
                                        )
                                    }
                                />
                                {/* <Link to={'/'}>{item.name}</Link> */}
                            </CustomTooltip>

                        </Menu.Item>
                    )
                })}
        </Menu>
    )

    const dropDownVisibleChange = () => {
        setIsOpenDropdown(!isOpenDropdown);
    }

    const controlDropdownMenu = () => {
        setIsOpenDropdown(false);
    };

    useEffect(() => {
        if (responsiveWidth < 650) {
            const layoutScroll = document.getElementById("layout_scroll");
            if (typeof layoutScroll !== 'undefined') {
                layoutScroll?.addEventListener('scroll', controlDropdownMenu);

                return () => {
                    layoutScroll?.removeEventListener('scroll', controlDropdownMenu);
                };
            }
        }
    });


    return (
        <>
            <div className="profile_container">
                <Dropdown
                    trigger={['click']}
                    overlay={drop_down_menus}
                    arrow={false}
                    placement="bottomLeft"
                    visible={isOpenDropdown}
                    onVisibleChange={() => dropDownVisibleChange()}
                >
                    <Button className="ant-dropdown-link full_h flex direction_column justify_center drop_down_">
                        <div className="user-data">
                            {userData ? <>{userData?.userName + ' '}</> : ''}
                            <div className="flex">
                                {menuItem && menuItem.length > 23 ? (
                                    <CustomTooltip
                                        className="header-dropdown-menu__tooltip"
                                        placement="bottom"
                                        title={(companyData && companyData.customerName) ? companyData.customerName : companyData}
                                    >
                                        <div>
                                            <p>{(companyData && companyData.customerName) ? companyData.customerName : companyData}</p>
                                        </div>
                                    </CustomTooltip>
                                ) : (
                                    <p>{(companyData && companyData.customerName) ? companyData.customerName : companyData}</p>
                                )}
                                <DropdownIco />
                            </div>
                        </div>
                    </Button>
                </Dropdown>
            </div>
        </>
    )
}

const mapDispatchToProps = { leftMenuToggle, rightMenuToggle, signout, addActiveCompanyData, clearSalaryListFunc }

const mapStateToProps = (state: any) => ({
    leftMenuStatus: state.home.leftMenuStatus,
    rightMenuStatus: state.home.rightMenuStatus,
    companyData: (state.user && state.user.companyData.result) ? state.user.companyData.result : state.user.companyData.name,
    loading: state.user.isCompChange
})


export default connect(mapStateToProps, mapDispatchToProps)(Profile)
